import FilterRegister from "../../../../components/filter/register-basic";
import reqCentroCusto from "../../../../services/reqMultiTenant/reqCentroCusto";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import Form from "../form";

const MainRegisterCostCenter = () => {
	const options = {
		id: "id_centrocusto", //usado para saber qual field usar para atualizar
		ident: "centerCost", //usado para definir os event listners
		identFilter: "filterCenterCost", //usado para definir os event listners
		title: "Departamento de Custo",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "nome", label: "Descrição do Departamento", align: "left" },
			{ key: "obs", label: "Observação", align: "left" },
			{ key: "empty1", label: "", align: "left" },
			{ key: "empty2", label: "", align: "left" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [{ id: 1, label: "Descrição do Departamento", value: "nome" }],
	};

	const fetch = async (filterData, newPage) => {
		const { param, paramValue, active } = filterData; //contem active que retorna true ou false

		const responseComplement = await reqCentroCusto.listPaginate(param, paramValue, active, newPage);

		return responseComplement;
	};

	const fetchID = async (currentId) => {
		const responseComplement = await reqCentroCusto.listID(currentId);

		return responseComplement;
	};

	const insert = async (data) => {
		const response = await reqCentroCusto.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={Form} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterCostCenter;
